<template>
	<div class="box">
		<transition-group name="item" tag="div">
			<div class="item" v-for="alert in alerts" :key="alert.id">
				{{ alert.text }}
				<p v-if="alert.critical">
					Error won't allow site works,
					<a href="#" @click="location.reload()">reload page</a>
				</p>
			</div>
		</transition-group>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex';

	export default {
		computed: {
			...mapGetters('alerts', { alerts: 'all' }),
			location(){
				return window.location;
			}
		}
	}
</script>
<style scoped>
	.box{
		position: fixed;
		right: 0;
		top: 0;
		width: 300px;
		z-index: 10000;
		padding: 10px 10px 0 0;
	}

	.item{
        margin: 0 0 10px 0;
        background: black;
        color: #fff;
        border: 1px solid #fff;
        border-radius: 16px;
        padding: 16px 24px;
        font-weight: 600;
        font-size: 18px;
	}

	.item-enter-active{
		animation: fadeIn 0.5s;
	}

	.item-leave-active{
		animation: fadeOut 0.5s;
	}

	@keyframes fadeIn{
		from{opacity: 0}
		to{opacity: 1}
	}

	@keyframes fadeOut{
		from{opacity: 1}
		to{opacity: 0}
	}

</style>
